import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { empty } from "rxjs/observable/empty";
import { AgenteService } from "../../services/agente/agente.service";
import { NavbarService } from "../../services/navbar/navbar.service";
import { ClientesService } from "./shared/services/clientes.service";
import { RedireccionService } from "../../services/redireccion/redireccion.service";
import { MensajeSnackBarService } from "../../services/mensaje-snack-bar/mensaje-snack-bar.service";
import { Paginacion } from "../../models/paginacion/paginacion.model";
import { FiltroBuscarCliente } from "../../models/filtro/filtro-buscar-cliente";
import { FiltroCliente } from "../../models/filtro/filtro-cliente";
import { ClienteService } from "../../services/cliente/cliente.service";
import { RedireccionMenu } from "../../models/menu/redireccion-menu.class";
import { OpcionVentana } from "../../contants/opcion-ventana.constant";

@Injectable()
export class MisClientesSandbox {
  private totalClientes: number;
  private clientesRequest: any;

  constructor(
    private route: Router,
    private agenteService: AgenteService,
    private clienteService: ClienteService,
    private navbarService: NavbarService,
    private clientesService: ClientesService,
    private redireccionService: RedireccionService,
    private mensajeSnackBarService: MensajeSnackBarService
  ) {}

  getClientes(paginacion: Paginacion): Observable<any[]> {
    this.clientesRequest = this.buildRequest(paginacion);
    return this.buscarClientes(this.clientesRequest);
  }

  getCotizacionesByPage(paginacion: Paginacion): Observable<any[]> {
    this.clientesRequest.paginacion = paginacion;

    return this.clientesService
      .buscarClientes(this.clientesRequest)
      .map((res) => res.clientes);
  }

  filtrarCotizaciones(filtros: any, paginacion: Paginacion): Observable<any[]> {
    let dniTomador = filtros.tipoDocumento
      ? filtros.tipoDocumento + filtros.noDocumento
      : null;

    this.clientesRequest = this.buildRequest(paginacion);
    this.clientesRequest.dniTomador = dniTomador;

    return this.buscarClientes(this.clientesRequest);
  }

  private buscarClientes(request: any): Observable<any[]> {
    return this.clientesService
      .buscarClientes(request)
      .map((res) => {
        this.totalClientes = res.clientes.length;
        if (this.totalClientes === 0) {
          this.mostrarMensaje(
            "No se encontraron clientes relacionadas al código de asesor seleccionado"
          );
        }
        return res.clientes;
      })
      .catch((error) => {
        this.mostrarMensaje("Ocurrio un ERROR con la aplicación: " + error);
        return empty();
      });
  }

  private buildRequest(paginacion: Paginacion) {
    let agente = this.agenteService.isPerfilAsesorOADelegado()
      ? this.agenteService.getCodigoAgente().toString()
      : null;

    return {
      paginacion: paginacion,
      cdAgente: agente,
      cdUsuario: this.agenteService.getUsuarioAgente().toString(),
    };
  }

  redirigir(clienteSelected: any) {
    const filtroBusqueda: FiltroBuscarCliente = new FiltroBuscarCliente(
      new FiltroCliente(
        clienteSelected.tipoDocumento,
        clienteSelected.numeroDocumento
      ),
      this.agenteService.getFiltroAgente()
    );
    let redireccionMenu = new RedireccionMenu("#/mis-clientes", false, false, OpcionVentana.CONSULTA_REGISTRA_CLIENTE_CS, "", "", "");
    redireccionMenu.filtroBuscarCliente = filtroBusqueda;

    this.clienteService.setfiltroBuscarCliente(filtroBusqueda);
    this.redireccionService.setRedireccionMenu(redireccionMenu);

    this.route.navigate(["Clientes"]);
  }

  capturarDetalleNavbar(): Observable<String> {
    if (!this.agenteService.isPerfilAsesorOADelegado()) {
      this.navbarService.setDetalle("aux");
    }
    return this.navbarService.selectedDetalle$;
  }

  buscarTiposDocumento(): Observable<any[]> {
    return this.clientesService.buscarTiposDocumento(
      this.agenteService.getCodigoPais(),
      this.agenteService.getgrupoPersona()
    );
  }

  mostrarMensaje(mensaje: String) {
    this.mensajeSnackBarService.mostrarMensajeWithPosition(
      mensaje,
      "center",
      "top"
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/mis-clientes/mis-clientes.sandbox.ts